export default __webpack_public_path__ + "static/media/semcasting-adobe.cdcb97fa.svg";